export const NOTIFICATION_EVENT_ACTIONS = {
    OpenFilespace: 'open-filespace',
    OpenFilespaceSnapshots: 'open-filespace-snapshots',
    OpenFilespaceLocalSettings: 'open-filespace-local-settings',
    DirectLink: 'direct-link',
    PinEntries: 'pin-entries',
    OpenFilespaceUpgrade: 'open-filespace-upgrade',
    CreateGuestLink: 'create-guest-link',
    Publish: 'publish',
};
